import { render, staticRenderFns } from "./DaysSlider.vue?vue&type=template&id=8762f1de&scoped=true"
import script from "./DaysSlider.vue?vue&type=script&lang=js"
export * from "./DaysSlider.vue?vue&type=script&lang=js"
import style0 from "./DaysSlider.vue?vue&type=style&index=0&id=8762f1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8762f1de",
  null
  
)

export default component.exports